import React from 'react';
import PropTypes from 'prop-types';
import { AdSlot } from 'react-dfp';
import styled from 'styled-components';
import adSettings from '~content/ads';

const AdWrapper = styled.div`
  text-align: center;
  border-top: 1px solid rgba(226, 226, 223, 1);
  border-bottom: 1px solid rgba(226, 226, 223, 1);
  padding: 1.5rem 0 2rem 0;
  margin-bottom: 3rem;
`;

const AdOverline = styled.p`
  font-size: 0.6875rem;
  color: #999;
  margin: 2rem 0 0.5em;
  text-align: center;
`;

const AdPosition = ({ positionId, overline }) => {
  const thisPosition = adSettings.positions[positionId];

  if (!thisPosition) {
    return null;
  }

  const sizes = thisPosition.sizeMapping.reduce(
    (accumulator, sizeMap) => [...accumulator, ...sizeMap.sizes],
    [],
  );

  return (
    <div>
      <AdOverline>
        <span className="bentonsanscond-n4">Advertisement</span>
      </AdOverline>
      <AdWrapper id={positionId}>

        <AdSlot
          slotId={positionId}
          sizes={sizes}
          sizeMapping={thisPosition.sizeMapping}
          targetingArguments={{
            pos: thisPosition.pos,
          }}
        />
      </AdWrapper>
    </div>
  );
};

AdPosition.propTypes = {
  positionId: PropTypes.string.isRequired,
  overline: PropTypes.bool,
};

AdPosition.defaultProps = {
  overline: false,
};

export default AdPosition;
